import React, { useRef, useEffect, useState } from 'react';
import { FiSliders } from 'react-icons/fi';
import './PostFilterNav.css';

const PostFilterNav = ({ activeFilter, onFilterChange, onSidebarToggle }) => {
  const filters = [
    { id: 'latest', label: 'Latest' },
    { id: 'top', label: 'Top Posts' },
    { id: 'following', label: 'Following' }
  ];

  const [dividerStyle, setDividerStyle] = useState({});
  const filterTabsRef = useRef(null);
  const followingTabRef = useRef(null);

  const handleFilterClick = (filterId) => {
    console.log(`Filter button clicked: ${filterId}`);
    onFilterChange(filterId);
  };

  useEffect(() => {
    const updateDividerPosition = () => {
      if (filterTabsRef.current && followingTabRef.current) {
        const tabsContainer = filterTabsRef.current;
        const followingTab = followingTabRef.current;
        const containerRect = tabsContainer.getBoundingClientRect();
        const followingRect = followingTab.getBoundingClientRect();
        
        // Calculate the position relative to the container
        const followingRight = followingRect.right - containerRect.left;
        
        // Use smaller gap on mobile (max-width: 480px)
        const isMobile = window.innerWidth <= 480;
        const gap = isMobile ? 65 : 16;
        
        setDividerStyle({
          left: `${followingRight + gap}px`, // Add gap between "Following" and the line
          right: '0px'
        });
      }
    };

    updateDividerPosition();
    window.addEventListener('resize', updateDividerPosition);
    
    return () => {
      window.removeEventListener('resize', updateDividerPosition);
    };
  }, []);

  return (
    <div className="post-filter-nav">
      {onSidebarToggle && (
        <button 
          className="mobile-filter-button"
          onClick={onSidebarToggle}
          aria-label="Toggle filters"
        >
          <FiSliders />
        </button>
      )}
      <div className="filter-tabs" ref={filterTabsRef}>
        {filters.map((filter) => (
          <button
            key={filter.id}
            ref={filter.id === 'following' ? followingTabRef : null}
            className={`filter-tab ${activeFilter === filter.id ? 'active' : ''}`}
            onClick={() => handleFilterClick(filter.id)}
          >
            <span className="filter-label">{filter.label}</span>
          </button>
        ))}
      </div>
      <div className="filter-divider" style={dividerStyle}></div>
    </div>
  );
};

export default PostFilterNav; 